import EndpointService from '../Service/EndpointService';
import { fromJS } from 'immutable';
import { LOAD_SINGLE_FREELANCER, UPDATE_SINGLE_FREELANCER } from '../Reducers/Freelancers';

// /freelancerportal/api/currentfreelancer

export function getFreelancersInClientTeam(clientid) {

    return new Promise((resolve, reject) => {

        EndpointService.post('/clientportal/api/freelancersinclientteam', { clientid: clientid }).then((response) => {
            resolve(fromJS(response.data));
        }).catch(reject)

    })


}

export function loadFreelancersInClientTeam(clientid) {

    return dispatch => {

        return new Promise((resolve, reject) => {

            EndpointService.post('/clientportal/api/freelancersinclientteam', { clientid: clientid }).then((response) => {
                dispatch({ 
                    type: LOAD_SINGLE_FREELANCER, 
                    collection: fromJS(response.data)
                });
            }).catch(reject)

        })

    }

}